import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { AuthFlow } from '@features/web-auth'
import { ROUTES } from '@shared/config/routes'
import logoUrl from '@/assets/images/logo.svg'
import styles from './AuthPage.module.css'

const PAGE_BG = '#e7ecf0'

/**
 * Страница /auth — обёртка над AuthFlow, читает ?redirect= из query.
 */
export const AuthPage = () => {
  const [params] = useSearchParams()
  const redirect = params.get('redirect') || ROUTES.HOME

  // body глобально белый (var(--white)). При открытой клавиатуре iOS
  // визуальный вьюпорт меньше layout-вьюпорта: .page (100svh) не накрывает
  // всю прокручиваемую область и снизу проступает белый body. Красим body
  // в фон страницы на время /auth, возвращаем исходный при уходе.
  useEffect(() => {
    const prev = document.body.style.backgroundColor
    document.body.style.backgroundColor = PAGE_BG
    return () => { document.body.style.backgroundColor = prev }
  }, [])

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <img src={logoUrl} alt="Secret Chat" className={styles.logo} />
        <div className={styles.content}>
          <AuthFlow redirectTo={redirect} />
        </div>
      </div>
    </div>
  )
}

export default AuthPage
